import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import PersonIcon from '@mui/icons-material/AccountCircle'
import { formatActivityCardTime } from '../activityUtils'
import { NO_RECORDING_MESSAGE } from './RRWebPlayer.constants'

export type VideoEmptyStateProps = {
  activityTypeDisplayName: string
  shortenedSegmentDurationSeconds: number
  segmentDurationSeconds: number
}

/**
 * Shown in place of the black rr-block screen while playback is inside a "dead space" (no video) activity
 */
export const VideoEmptyState: FC<VideoEmptyStateProps> = ({ activityTypeDisplayName, shortenedSegmentDurationSeconds, segmentDurationSeconds }) => (
  <Stack
    data-testid="video-empty-state"
    sx={{
      position: 'absolute',
      inset: 0,
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'var(--spacing-2xs)',
      backgroundColor: '#000000',
      color: 'var(--text-inverted)',
      textAlign: 'center',
      zIndex: 20
    }}
  >
    <PersonIcon sx={{ height: '3rem', width: '3rem', color: 'var(--yellow-500)' }} />
    <Typography variant="h6">{activityTypeDisplayName}</Typography>
    <Typography>{NO_RECORDING_MESSAGE}</Typography>
    <Box sx={{ width: '12rem', borderTop: '0.0625rem solid var(--shape-action-transparent)', marginY: 'var(--spacing-2xs)' }} />
    <Typography variant="caption">Duration (This Segment)</Typography>
    <Typography data-testid="video-empty-state-segment-duration" sx={{ color: 'var(--yellow-500)' }}>
      {formatActivityCardTime(shortenedSegmentDurationSeconds)}
    </Typography>
    <Typography variant="caption">Total Duration</Typography>
    <Typography data-testid="video-empty-state-total-duration">{formatActivityCardTime(segmentDurationSeconds)}</Typography>
  </Stack>
)
